module.exports = __webpack_public_path__ + "img/appstore.504e1308.png";